<template>
  <expert-layout>
    <v-layout wrap>
      <v-flex xs12 class="mx-3">
        <v-toolbar flat dense color="toolbarColor">Video Project Details</v-toolbar>
      </v-flex>
      <!-- job details -->
      <video-project-details :project="videoProject" :coverMedia="coverMedia"></video-project-details>
      <!-- end -->
    </v-layout>
  </expert-layout>
</template>

<script>
import VideoProjectDetails from "../_components/more_details";
import { mapGetters } from 'vuex';
export default {
  name: "VideoProjectDetailsPage",
  components: {
    VideoProjectDetails
  },
  computed: {
    ...mapGetters(['user']),
    ...mapGetters(["host"])
  },
  data() {
    return {
      videoProject: {},
      coverMedia: [],
    };
  },
  methods: {},
  created() {
    const id = this.$route.params.id;
    this.$store
      .dispatch("get", "/videoproject/" + this.user._id + '/' + id)
      .then(res => {
        this.videoProject = res.project;
        this.coverMedia.push({
          thumb: `${this.host}/uploads/video_projects/${this.videoProject.videoCoverImage}`,
          src: `${this.host}/uploads/video_projects/${this.videoProject.videoCoverImage}`,
          caption: this.videoProject.title,
        })
        /*this.project.images.forEach(image => {
          this.media.push({
              thumb: `${this.host}/uploads/projects/${image}`,
              src: `${this.host}/uploads/projects/${image}`,
            })
        });
        this.coverMedia.push({
          thumb: `${this.host}/uploads/projects/${this.project.coverImage}`,
          src: `${this.host}/uploads/projects/${this.project.coverImage}`,
          caption: this.project.title,
        })*/
      });
  }
};
</script>
